<template>
    <div>
      <p>Hello Testing {{evenNumber}}</p>
        <vs-button @click="methodClick()">Button</vs-button>
    </div>
    
</template>

<script>
export default {
  data () {
    return {
      evenNumber:0
    }
  },
  methods:{
    methodClick () {
      this.evenNumber++
      
    }
  },
  watch:{
    evenNumber () {
      
    }
  }
}

</script>

<style scoped>
/* div{
  margin: 5px;
} */
</style>